export default __webpack_public_path__ + "static/media/13t.38e78781.jpg";